import styled from 'styled-components'
import DefaultLayout from '../components/molecules/common/DefaultLayout'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Text from '../components/atoms/Text';
import MainButton from '../components/atoms/MainButton';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getUserInfo } from '../api/home';
import { logEvent } from '../utils/eventLogger';

const Wrapper = styled.div`
  padding: 20px;
  height: 100dvh;
  display: flex;
  flex-direction: column;
`
const ContentSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transform: translateY(-10%);
`
const TextWrapper = styled.div`
  margin-top: 36px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  word-break: keep-all;
  }
`
const MobileBr = styled.br`
  display: none;
  @media (max-width: 600px) {
    display: inline;
  }
`
const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 600px; 
  padding: 0 20px;
`
const CompleteIcon = styled(CheckCircleRoundedIcon)`
  color: ${(props) => props.theme.colors.secondary};
`
const TextButton = styled.button`
  margin-top: 8px;
  background: none;
  border: none;
  cursor: pointer;
`

const SignupComplete = () => {
  const [userInfo, setUserInfo] = useState({})
  const navigate = useNavigate();

  useEffect(() => {
      const fetchUserInfo = async() => {
          try {
            const rlt = await getUserInfo();
            // console.log(rlt)
            setUserInfo(rlt)
            
          } catch (err) {
            console.error(err);
            // console.log(err)
          }
        }
        fetchUserInfo()
      }, [])
    
  // 아이 이름 뒤 조사 '이' 추가 함수
  const getPostfixI = (name) => {
    if (!name) return '';
    const lastChar = name[name.length - 1];
    const code = lastChar.charCodeAt(0) - 0xac00;
    return code % 28 !== 0 ? '이' : '';
  };

  const childName = `${userInfo.childName}${getPostfixI(userInfo.childName)}`

  return (
    <DefaultLayout>
      <Wrapper>
      <ContentSection>
        <CompleteIcon sx={{ fontSize: 70 }}/>
        <TextWrapper>
          <Text variant="headline2" weight="bold">
            {childName}의 음성이 성공적으로 <MobileBr />
            등록되었어요!
          </Text>
          <Text color="alternative">
            지금 바로 아이만의 표현을 기록하고 <MobileBr />
            우리 아이의 언어 습관을 확인해보세요!
          </Text>
        </TextWrapper>
      </ContentSection>

      <ButtonWrapper>
        <MainButton
          variant="secondary"
          title="아이만의 표현 기록하기"
          onClick={() => {
            logEvent("word_register_start")
            navigate('/words/new')
          }}
        />
        <TextButton
          onClick={() => navigate('/')}>
          <Text variant="body2">홈으로 가기</Text>
        </TextButton> 
      </ButtonWrapper>
      </Wrapper>
    </DefaultLayout>
  )
}

export default SignupComplete
